import { Box } from '@mui/material';
import Background from '../../assets/images/bg/collection_2026/star_bg_gray.png';
import Logo from '../../assets/images/logo/starcard_club_dark.png';
import MenuBar from './MenuBar';

const HomepageLayout = ({ children }) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        position: 'relative',
        background: `url(${Background}) center center / cover, #FAFAFA`,
      }}
    >
      <Box component={'header'} sx={{ width: '100%', height: '60px' }}>
        <Box component={'img'} src={Logo} alt="Starcard Club Logo" sx={{ height: '60px' }} />
      </Box>
      <Box
        component={'main'}
        maxWidth={'md'}
        mx={'auto'}
        sx={{
          padding: '10px 16px 45px',
          overflowX: 'hidden',
          overflowY: 'auto',
          width: '100%',
          height: 'calc(100vh - 130px)',
        }}
      >
        {children}
      </Box>
      <MenuBar />
    </Box>
  );
};
export default HomepageLayout;
